import { z } from 'zod';
import type { Organization } from '../types/state';

export const businessActivitySchema = z.object({
  entityType: z.string().min(1, 'This field is required'),
  activityDescription: z.string().optional(),
  annualTurnover: z.string().min(1, 'This field is required'),
  yearlyTransactionVolume: z.string().min(1, 'This field is required'),
  maxSinglePaymentAmount: z.string().min(1, 'This field is required'),
});

export type BusinessActivitySchema = z.infer<typeof businessActivitySchema>;

export function hasBusinessActivity(organization: Organization): boolean {
  return businessActivitySchema.safeParse({
    entityType: organization.entityType,
    annualTurnover: organization.annualTurnover,
    activityDescription: organization.activityDescription,
    yearlyTransactionVolume: organization.yearlyTransactionVolume,
    maxSinglePaymentAmount: organization.maxSinglePaymentAmount,
  }).success;
}
